import { AxiosInstance } from 'axios';

import { Color, Colors } from '../../types/Color';
import { DeleteItemsInput } from '../../types/DeleteItemsInput';
import { colorEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { CreateColorInput } from './ColorsApi.schema';

class ColorsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (color: CreateColorInput): Promise<Color> => {
    return this.#requestInstance.post(colorEndpoints.color, color);
  };

  getColors = async (): Promise<Colors> => {
    return this.#requestInstance.get(colorEndpoints.color);
  };

  deleteColor = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(colorEndpoints.getColorById(id));
  };

  deleteManyColors = async (input: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(colorEndpoints.color, { data: input });
  };

  getColorById = async (id: number): Promise<Color> => {
    return this.#requestInstance.get(colorEndpoints.getColorById(id));
  };

  updateColor = async (color: Color): Promise<Color> => {
    return this.#requestInstance.patch(colorEndpoints.getColorById(+color?.id), {
      name: color?.name,
      color: color?.color,
    });
  };
}

export const colorsApi = new ColorsApi(axios);
